export function formHandler() {
  // Helper function to check if a field has content
  function hasContent(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      return field.checked;
    }
    if (field.tagName === 'SELECT') {
      return field.value !== '' && field.value !== null;
    }
    return field.value.trim() !== '';
  }

  // Helper function to toggle label visibility based on field state
  function toggleLabel(field) {
    const gfield = field.closest('.gfield');
    if (!gfield) return;

    const label = gfield.querySelector('label.gfield_label');
    if (!label) return;

    // Check if this is the Newsletter form
    const form = field.closest('form');
    const isNewsletterForm = form && form.id === 'gform_1';

    const isFocused = document.activeElement === field;
    const hasValue = hasContent(field);

    // Handle select field padding
    if (field.tagName === 'SELECT') {
      if (hasValue) {
        field.classList.add('has-value');
      } else {
        field.classList.remove('has-value');
      }
    }

    // Remove all state classes first
    label.classList.remove('hidden', 'focused');

    // Apply appropriate state
    if (isFocused) {
      if (isNewsletterForm) {
        // Newsletter form: hide label when focused (old behavior)
        label.classList.add('hidden');
      } else {
        // Other forms: move label above with white color and smaller font
        label.classList.add('focused');
      }
    } else if (hasValue) {
      // When has content but not focused, hide the label
      label.classList.add('hidden');
    }
    // Otherwise, label stays in default position (centered)
  }

  // Handle focus events (clicking or tabbing into a field)
  document.addEventListener('focusin', function(e) {
    if (e.target.matches('.gform_wrapper input:not([type="submit"]):not([type="button"]), .gform_wrapper textarea, .gform_wrapper select')) {
      toggleLabel(e.target);
    }
  });

  // Handle blur events (clicking or tabbing away from a field)
  document.addEventListener('focusout', function(e) {
    if (e.target.matches('.gform_wrapper input:not([type="submit"]):not([type="button"]), .gform_wrapper textarea, .gform_wrapper select')) {
      toggleLabel(e.target);
    }
  });

  // Handle input events (typing, pasting, deleting)
  document.addEventListener('input', function(e) {
    if (e.target.matches('.gform_wrapper input:not([type="submit"]):not([type="button"]), .gform_wrapper textarea, .gform_wrapper select')) {
      toggleLabel(e.target);
    }
  });

  // Handle change events for checkboxes, radios, and selects
  document.addEventListener('change', function(e) {
    if (e.target.matches('.gform_wrapper input[type="checkbox"], .gform_wrapper input[type="radio"], .gform_wrapper select')) {
      toggleLabel(e.target);
    }
  });

  // Initialize: hide labels for fields that already have content (e.g., pre-filled values)
  function initializeFields() {
    const fields = document.querySelectorAll('.gform_wrapper input:not([type="submit"]):not([type="button"]), .gform_wrapper textarea, .gform_wrapper select');
    fields.forEach(field => {
      toggleLabel(field);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFields);
  } else {
    initializeFields();
  }

  // Also initialize when Gravity Forms loads content via AJAX
  // gform_post_render is a jQuery event, so we must use jQuery to listen
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('gform_post_render', initializeFields);
  }
}